import { Fragment } from 'react';
import { useSpring, config, animated } from '@react-spring/web';
import { useTheme } from '@shopify/polaris-viz-core';
import styles from '../../DonutChart.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { classNames } from '../../../../utilities/classnames.js';
import { ComparisonMetric } from '../../../ComparisonMetric/ComparisonMetric.js';

function InnerValue({
  activeValue,
  activeIndex,
  comparisonMetric,
  labelFormatter,
  isAnimated,
  renderInnerValueContent,
  totalValue
}) {
  var _renderInnerValueCont;

  const selectedTheme = useTheme();
  const {
    animatedValue
  } = useSpring({
    animatedValue: totalValue,
    from: {
      animatedValue: 0
    },
    config: config.stiff,
    default: {
      immediate: !isAnimated
    }
  });

  const animatedTotalValue = /*#__PURE__*/jsx(animated.span, {
    children: animatedValue.to(value => animatedValue.isPaused ? labelFormatter(value) : labelFormatter(Math.abs(Math.floor(value))))
  });

  const activeValueExists = activeValue !== null && activeValue !== undefined;
  const valueToDisplay = activeValueExists ? activeValue : animatedTotalValue;
  const innerContent = (_renderInnerValueCont = renderInnerValueContent === null || renderInnerValueContent === void 0 ? void 0 : renderInnerValueContent({
    activeValue,
    activeIndex,
    animatedTotalValue,
    totalValue
  })) !== null && _renderInnerValueCont !== void 0 ? _renderInnerValueCont : /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(animated.p, {
      className: classNames(styles.ContentValue),
      style: {
        color: selectedTheme.xAxis.labelColor
      },
      children: valueToDisplay
    }), comparisonMetric != null && !activeValueExists && /*#__PURE__*/jsx("div", {
      className: styles.ComparisonMetric,
      children: /*#__PURE__*/jsx(ComparisonMetric, {
        metric: comparisonMetric.metric,
        trend: comparisonMetric.trend,
        accessibilityLabel: comparisonMetric.accessibilityLabel
      })
    })]
  });
  return /*#__PURE__*/jsx("div", {
    className: styles.ContentWrapper,
    children: innerContent
  });
}

export { InnerValue };
